import { NgModule } from '@angular/core';

import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/cache';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { environment } from '@src/environments/environment';
const uri = `${environment.apiUrl}/api/graphql`;

export const createApollo = () => ({
    link: new BatchHttpLink({
        uri,
    }),
    cache: new InMemoryCache({
        dataIdFromObject: (object) => {
            const productId = object.selectedConsoleId
                ? object.selectedConsoleId + '-' + object.id
                : object.id;
            return productId ? `${object.__typename}_${productId}` : null;
        },
    }),
});

@NgModule({
    exports: [ApolloModule],
    providers: [
        {
            provide: APOLLO_OPTIONS,
            useFactory: createApollo,
        },
    ],
})
export class GraphQLModule {}
